import React from "react";
import {useAuth0} from "../utils/Auth0Provider";
import {MessageBar, MessageBarType, PrimaryButton} from "office-ui-fabric-react";

export function LoginScreen() {
  const {loginWithRedirect, logout, authError} = useAuth0();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh"
      }}
    >
      {authError ? (
        <>
          {/* Auth0 still has a session for this account, so Login would
              return the same error. Logging out lets the user switch account. */}
          <h1>Login failed.</h1>
          <MessageBar messageBarType={MessageBarType.error} styles={{root: {maxWidth: 480, marginBottom: 24}}}>
            {authError}
          </MessageBar>
          <PrimaryButton onClick={() => logout()}>Log out</PrimaryButton>
        </>
      ) : (
        <>
          <h1>You must login.</h1>
          <PrimaryButton onClick={() => loginWithRedirect()}>Login</PrimaryButton>
        </>
      )}
    </div>
  );
}
